export const UNCATEGORIZED = 'uncategorized';
export const LIVE_CASINO_CATEGORY = 28;
